import { isString } from '@cutwise/utils';

export const KEY_USER = 'user';
export const KEY_AUTH_TOKEN = 'auth_token';
export const KEY_CONSTANTS = 'constants';
export const KEY_URI_AFTER_AUTH = 'uri-after-auth';
export const KEY_URI_AFTER_TOP_UP = 'uri-after-top-up';
export const KEY_AUTH_REDIRECT_STARTED = 'auth-redirect-started';
export const KEY_WAS_LOGGED_OUT = 'was-logged-out';
export const KEY_IS_SIDEBAR_OPENED = 'is-sidebar-opened';
export const KEY_E2E = 'e2e';
export const KEY_VIEWER_PRESET_ID = 'viewer-preset-id';
export const KEY_STEREO_MODE = 'stereo-mode';
export const KEY_RECENT_DRIVE_DESTINATIONS = 'recent-drive-destinations';
export const KEY_NON_OWNER_SWEET_LINE = 'sweet-line';
export const KEY_DEBUG = 'debug';
export const KEY_DEBUG_SETTINGS = 'debug-settings';
export const KEY_CV_LAST_CONTROL = 'cv-last-control';
export const KEY_PINNED_ITEMS = 'pinned-items';
export const KEY_SPECTRUM_UPLOAD_MODEL = 'spectrum-upload-model';
export const KEY_COLLECTION_PREVIEWS = 'collection-previews';
export const KEY_READ_ALERTS = 'cutwise-read-alerts';
export const KEY_DEADZONES_PENDING_TASKS = 'cutwise-aset-pending-tasks';
export const KEY_SPECTRUM_PENDING_TASKS = 'cutwise-spectrum-pending-tasks';
export const KEY_DEADZONES_INSPECTOR_COLLAPSE_NAVIGATION = 'cutwise-deadzones-inspector-collapse-navigation';
export const KEY_DEADZONES_INSPECTOR_PARAMS = 'cutwise-deadzones-inspector-params';
export const KEY_DEADZONES_INSPECTOR_HIDE_DESCRIPTION = 'cutwise-deadzones-inspector-hide-description';
export const KEY_PATH_BEFORE_FANCY_COLOR_GRADING = 'uri-before-fancy-color-grading';
export const KEY_FCRF_DEMO = 'fcrf-demo';
export const KEY_FCRF_WALKTHROUGH_CLOSED = 'fcrf-walkthrough-closed';
export const KEY_SERVICES_PENDING_SERVICE = 'services-pending-service';
export const KEY_GUEST_ID = 'guest_id';

/** @deprecated */
export const KEY_TOKEN = 'token';
/** @deprecated */
export const KEY_ACCESS_TOKEN = 'access-token';
/** @deprecated */
export const KEY_ACCESS_TOKEN_LEGACY = 'access_token';

type StorageType = WindowLocalStorage['localStorage'] | WindowSessionStorage['sessionStorage'];
type ContentType = Any;

export default class Storage {
  static get STORAGE_SESSION() {
    return window.sessionStorage;
  }

  static get STORAGE_LOCAL() {
    return window.localStorage;
  }

  // get object value from storage
  static getObject(key: string, storage: StorageType) {
    if (!key || !storage) {
      return null;
    }

    let value = null;
    const json = storage.getItem(key);

    if (json) {
      try {
        value = JSON.parse(json);
      } catch (err) {
        value = json;
      }
    }

    return value;
  }

  // get object value from storage
  static hasObject(key: string, storage: StorageType) {
    return Storage.getObject(key, storage) !== null;
  }

  // save object to storage
  static saveObject(key: string, content: ContentType, storage: StorageType) {
    if (!key || !storage) {
      return;
    }

    let value = content;

    if (typeof content !== 'string') {
      value = JSON.stringify(content);
    }

    storage.setItem(key, value);
  }

  // deletes object from storage
  static removeObject(key: string, storage: StorageType) {
    if (!key || !storage) {
      return;
    }

    storage.removeItem(key);
  }

  // add value to array in storage
  static push(key: string, content: ContentType, storage: StorageType) {
    if (!key || !storage) {
      return;
    }

    const currentContent = Storage.getObject(key, storage);
    const parsedContent = currentContent && !isString(currentContent) ? `${currentContent}` : currentContent;
    const result = parsedContent?.split(',') ?? [];

    result.push(content);

    Storage.saveObject(key, result.join(','), storage);
  }

  // remove value from array in storage
  static pullout(key: string, content: ContentType, storage: StorageType) {
    if (!key || !storage) {
      return;
    }

    const currentContent = Storage.getObject(key, storage);
    const result = currentContent?.split(',') ?? [];
    const nextResult = result.filter((v: string) => v !== content).join(',');

    if (nextResult) {
      Storage.saveObject(key, nextResult, storage);
    } else {
      Storage.removeObject(key, storage);
    }
  }
}
export type { StorageType };
